export default {
  labels: {
    selectOne: 'Sélectionnez une option',
    selectAll: 'Sélectionnez toutes les options applicables',
    typeResponse: 'Tapez votre réponse dans la zone de texte ci-dessous.',
    recordResponse: 'Enregistrez une réponse pour répondre à la question.',
    enterNumeric: 'Entrez une réponse numérique dans le champ ci-dessous.',
    rateResponseScale: 'Évaluez votre réponse sur l’échelle fournie.',
    sliderMinimum: 'Valeur minimale : {value}',
    sliderMaximum: 'Valeur maximale : {value}',
    selectOneOptionRow: 'Sélectionnez une option dans chaque ligne.',
    selectAllOptionsRow: 'Sélectionnez toutes les options applicables pour chaque ligne.',
    dragAndDropResponse: 'Faites glisser et déposez les options pour les classer par ordre de préférence.',
    rankOrderDesktopInstruction: 'Glissez-déposez les éléments pour les classer, ou utilisez le bouton + pour ajouter un élément. Utilisez les boutons fléchés pour réorganiser ou le bouton supprimer pour retirer un élément.',
    alert: "Alerte",
    error: 'Veuillez saisir un nombre entre {min} et {max}.',
    cameras: 'Caméras',
    microphones: 'Microphones',
    recording: 'Enregistrement',
    noDevicesFound: 'Aucun périphérique trouvé',
    camera: 'Caméra',
    microphone: 'Microphone',
    stopRecording: 'Arrêter l’enregistrement',
    startRecording: 'Démarrer l’enregistrement',
    disableCamera: 'Désactiver la caméra',
    enableCamera: 'Activer la caméra',
    disableMicrophone: 'Désactiver le microphone',
    enableMicrophone: 'Activer le microphone',
    settings: 'Paramètres',
    recordingProgress: 'Progression de l\'enregistrement',
    playbackProgress: 'Progression de la lecture',
    play: 'Lecture',
    pause: 'Pause',
    stop: 'Arrêter',
    record: 'Enregistrer',
    recordAgain: 'Enregistrer à nouveau',
    retry: 'Réessayer',
    done: 'Terminé',
    minRecordTime: 'Veuillez enregistrer une réponse pendant {min} secondes.',
    enlargeImage: 'Agrandir l\'image',
    enlargedImage: 'Image agrandie',
    close: 'Fermer',
    zoomIn: 'Zoomer',
    zoomOut: 'Dézoomer',
    resetZoom: 'Réinitialiser le zoom',
    zoomLevel: 'Zoom {percentage}%',
    imagePosition: '{current} sur {total}',
    previousImage: 'Image précédente',
    nextImage: 'Image suivante',
    imageLoading: 'Chargement de l\'image',
    imageLoadFailed: 'Impossible de charger l\'image',
  },
  noSelection: 'Aucune sélection',
  actions: {
    increase: 'Augmenter',
    decrease: 'Diminuer'
  },
  survey: {
    endOfSurvey: {
      titleTerminated: 'Aperçu de l\'Enquête Terminé',
      titleCompleted: 'Aperçu de l\'Enquête Complété',
      previewModeWarning: 'Cette page n\'est visible qu\'en Mode Aperçu et ne sera pas montrée aux répondants réels.',
      reachedEndPoint: 'Cette enquête a atteint un point final.',
      reachedEndPointCompleted: 'Cet aperçu a atteint un point final.',
      returnToModify: 'Revenez à la question précédente pour modifier vos réponses et tester un autre parcours d\'enquête.',
      logic: 'Logique'
    }
  }
}
